/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientProgramsDeltaResponseModel } from '../../models/patient-programs-delta-response-model';

export interface GetPatientProgramsDelta$Params {
  patientID?: number;
  onlyActive?: boolean;
  sinceCursor?: string;
}

export function GetPatientProgramsDelta(http: HttpClient, rootUrl: string, params?: GetPatientProgramsDelta$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientProgramsDeltaResponseModel>> {
  const rb = new RequestBuilder(rootUrl, GetPatientProgramsDelta.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('onlyActive', params.onlyActive, {});
    rb.query('sinceCursor', params.sinceCursor, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientProgramsDeltaResponseModel>;
    })
  );
}

GetPatientProgramsDelta.PATH = '/api/Supervisor/GetPatientProgramsDelta';
